import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/admin/scim")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/scim" });
	},
});
